import { Befehl } from '../models'
import { findAuftrag, hasFieldContent } from './helpers'
import { hasBefehlGenericEmptyFields } from './generic'

/**
 * Checks if Befehl 23 has empty fields.
 *
 * First checks if ANY field is empty (generic check).
 * Then checks specific business rules:
 * - 23.10: requires both 23.11 AND 23.12 zugmeldestelle.name content
 * - Returns true if ANY field is empty (warns if either is missing)
 *
 * Aufträge without felder are never considered to have empty fields.
 * Boolean field values are never considered empty fields.
 */
export function hasBefehl23EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  // First check if ANY field is empty
  if (hasBefehlGenericEmptyFields(befehl)) {
    return true
  }

  // Then check specific business rules
  const auftrag2310 = findAuftrag(befehl, '23.10')
  if (auftrag2310) {
    const has2311Name = hasFieldContent(
      auftrag2310,
      '23.11',
      'zugmeldestelle.name'
    )
    const has2311Art = hasFieldContent(
      auftrag2310,
      '23.11',
      'zugmeldestelle.art'
    )
    const has2312Name = hasFieldContent(
      auftrag2310,
      '23.12',
      'zugmeldestelle.name'
    )
    const has2312Art = hasFieldContent(
      auftrag2310,
      '23.12',
      'zugmeldestelle.art'
    )

    // Return true if ANY field is empty (either 23.11 OR 23.12 is empty)
    return !has2311Name || !has2311Art || !has2312Name || !has2312Art
  }

  return false
}
